// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1Xkxl","empty":"ModalGraph_empty__CnipL"};